const SocItem = ({styles, data}) => {
  return (
    <div className={styles.socialLogo}>
      <img src={data.logo} alt={data.title} />
    </div>
  );
}

export default SocItem;
